import React from 'react'
import { useStyle } from "./Style";
import Grid from "@material-ui/core/Grid";
import Box from '@mui/material/Box';
import SkeletonWrapper from '../../../../../containers/NewProductList/components/SkeletonWrapper/SkeletonWrapper';
import DisplayAmlPolicies from '../Policies/DisplayAmlPolicies';

const FlpPoliciesWrapper = (props) => {
  const classes = useStyle();

  if (props.loader) {
    return <SkeletonWrapper loading={props.loader} />
  }

  return (
    <>
      <section className={classes.claimswrapper}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12}>
            <Box sx={{ p: 0 }}>
              <DisplayAmlPolicies
                policies={props.policies}
                loader={props.loader}
              />
            </Box>
          </Grid>
        </Grid>
      </section>
    </>
  )
}

export default FlpPoliciesWrapper